import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Leaf, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const differences = [{
  title: 'Insured & Vetted',
  description: 'Every crew member passes strict background checks. Fully insured for your protection.',
  icon: ShieldCheck
}, {
  title: 'Eco-Friendly Options',
  description: 'Tough on dirt, safe for your family and pets. We use premium, responsible products.',
  icon: Leaf
}, {
  title: 'Transparent Pricing',
  description: 'No hidden fees. No surprises. You know exactly what you pay before we start.',
  icon: BadgeDollarSign
}, {
  title: 'Satisfaction Guaranteed',
  description: "If you aren't thrilled with the reset, we come back and fix it. Zero drama.",
  icon: ThumbsUp
}];
export function Difference() {
  return <section id="difference" className="py-32 bg-ink relative overflow-hidden" data-id="element-33">
      <div className="container mx-auto px-8 lg:px-12 relative z-10" data-id="element-34">
        <div className="flex flex-col lg:flex-row gap-20 items-start" data-id="element-35">
          <div className="lg:w-1/3 lg:sticky lg:top-32" data-id="element-36">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} data-id="element-37">
              <div className="flex items-center gap-4 mb-6" data-id="element-38">
                <div className="w-8 h-[1px] bg-lime" data-id="element-39"></div>
                <span className="text-paper/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-40">
                  The Standard
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl text-paper font-light leading-tight mb-8" data-id="element-41">
                The Nítido <br data-id="element-42" />
                <span className="font-medium" data-id="element-43">Difference.</span>
              </h2>
              <p className="text-concrete/80 font-light text-base leading-relaxed mb-10" data-id="element-44">
                We don't just wipe surfaces. We deliver a premium,
                architectural-grade clean that resets your environment
                completely.
              </p>
              <a href="#quote" className="inline-block border border-paper/30 text-paper px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-paper hover:text-ink transition-colors" data-id="element-45">
                Experience It
              </a>
            </motion.div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16" data-id="element-46">
            {differences.map((diff, index) => {
            const Icon = diff.icon;
            return <motion.div key={diff.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1,
              ease: 'easeOut'
            }} className="border-t border-graphite pt-8" data-id="element-47">
                  <div className="mb-6 text-lime" data-id="element-48">
                    <Icon size={24} strokeWidth={1.5} data-id="element-49" />
                  </div>
                  <h4 className="text-lg text-paper font-medium mb-3 tracking-wide" data-id="element-50">
                    {diff.title}
                  </h4>
                  <p className="text-concrete/70 font-light text-sm leading-relaxed" data-id="element-51">
                    {diff.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}